import MrSelala from '../assets/MrSelala.jpg';
import MrMmela from '../assets/MrMmela.jpg';
export const TeamMembers = [
    {
        name:"Mr. Selala",
        position:"CEO",
        image:MrSelala,
        instagram:"",
        twitter:"",
        linkedin:"",
        email:"",
    },
    {
        name:"Mr. Mmela",
        position:"COO",
        image:MrMmela,
        instagram:"",
        twitter:"",
        linkedin:"",
        email:"",
    },
    
]